import React from "react"; 
import OrderAttemdanceWindowListPageContainer from "./OrderAttemdanceWindowListPageContainer";
export class OrderAttemdanceWindowListPage extends React.Component {
  render() {
    return <OrderAttemdanceWindowListPageContainer {...this.props} />;
  }
}
